<template>
  <div class="motivate-add">
    <el-form
      :model="otherForm"
      label-width="120px"
      style="padding-right: 40px"
      :rules="otherRules"
      ref="otherFormRefs"
      size="small"
    >
      <el-form-item label="名称" prop="name">
        <el-input v-model="otherForm.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="对应师傅" prop="responsibleUserId">
        <el-select
          v-model="otherForm.responsibleUserId"
          placeholder="请选择对应师傅"
          style="width: 100%"
          filterable
        >
          <el-option
            :label="item.userName"
            v-for="item in userList"
            :key="item.id"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="正/负" prop="incentiveType">
        <el-select
          v-model="otherForm.incentiveType"
          placeholder="请选择"
          style="width: 100%"
        >
          <el-option label="正" :value="1"></el-option>
          <el-option label="负" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="金额" prop="amount">
        <el-input v-model="otherForm.amount"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="otherForm.remark"
          placeholder="请输入..."
          type="textarea"
        ></el-input>
      </el-form-item>
      <el-form-item label="附件">
        <UpLoad
          :fileSize="100"
          ref="uploadRefs"
          @remove="removeFile"
          :limit="100"
          @uploadSuccess="handleUploadSuccess"
        ></UpLoad>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import UpLoad from "@/components/UpLoad";
import { validateNumber } from "@/utils/index";
export default {
  name: "Other",
  components: {
    UpLoad,
  },
  props: {
    dialogFlag: {
      type: Boolean,
      default: false,
    },
    responsibleUserId: {
      type: Number,
      default: null,
    },
    userList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      otherForm: {
        name: "",
        incentiveType: 1,
        amount: "",
        remark: "",
        attachmentIds: [], // 附件id
        responsibleUserId: null, // 对应师傅ID
      },
      otherRules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 1,
            max: 100,
            message: "长度在 1 到 100 个字符",
            trigger: "blur",
          },
        ],
        responsibleUserId: [
          { required: true, message: "请选择对应师傅", trigger: "change" },
        ],
        incentiveType: [
          { required: true, message: "请选择正/负", trigger: "change" },
        ],
        amount: [
          { required: true, message: "请输入金额", trigger: "blur" },
          { validator: validateNumber, trigger: "blur" },
        ],
      },
      fileList: [],
    };
  },
  watch: {
    dialogFlag: {
      handler(val) {
        if (val) {
          this.otherForm.attachmentIds = [];
          // 设置默认师傅ID
          if (this.responsibleUserId) {
            this.otherForm.responsibleUserId = this.responsibleUserId;
          }
        }
      },
      immediate: true,
    },
    responsibleUserId: {
      handler(val) {
        if (val && this.dialogFlag && !this.otherForm.responsibleUserId) {
          this.otherForm.responsibleUserId = val;
        }
      },
      immediate: true,
    },
    "otherForm.attachmentIds": {
      handler(val) {
        if (val.length > 0) {
          this.getFileList(val);
        }
      },
      deep: true,
    },
  },
  methods: {
    getFileList(val) {
      this.axios({
        url: "/attachment/list",
        method: "POST",
        data: {
          ids: val.join(","),
        },
      }).then((res) => {
        if (res.data.data && res.data.data.length > 0) {
          this.fileList = res.data.data.map((item) => {
            return {
              name: item.fileName,
              url: item.fileUrl,
              uid: item.id,
            };
          });
          this.$refs.uploadRefs.fileList = this.fileList;
        }
      });
    },
    removeFile(file, fileList) {
      this.otherForm.attachmentIds = fileList.map((item) => item.uid);
    },
    handleUploadSuccess(res) {
      this.otherForm.attachmentIds.push(res);
    },
  },
};
</script>

<style scoped></style>
